import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './Reducers';
import api from './Api';
import graph from './Graph';
import history from 'react-router/lib/browserHistory';
import alert from 'react-s-alert';
import session from './Session';
import token from './Token';

const createStoreWithMiddleware = applyMiddleware(
    thunkMiddleware.withExtraArgument({ api, history, alert, session, token, graph })
)(createStore);

export default function configureStore() {
    const store = createStoreWithMiddleware(rootReducer,{});
    return store;
}


// WEBPACK FOOTER //
// ./src/Stores.js